import React, { useState } from 'react';
import { Lightbulb, BookOpen, Target, Sparkles, TrendingUp, User, ArrowRight, Bookmark, MessageCircle, Compass, Zap, CheckCircle2, Clock, Star, ChevronRight } from 'lucide-react';

export default function EssayIdeasHybrid() {
  // Simulated user state - would come from actual data
  const [userState] = useState({
    assessmentComplete: true,
    freeWritesCount: 10,
    savedIdeasCount: 3,
    essaysStarted: 0,
    essaysTotal: 5,
    essaySlots: 15,
    essaySlotsStarted: 2,
    hasPersonalizedTopics: true,
    recentActivity: [
        { type: 'freewrite', title: 'Morning thoughts on leadership', date: 'Today, 8:42 AM' },
        { type: 'draft', title: 'Common App Essay - Draft 2', date: 'Yesterday' },
        { type: 'idea', title: 'The Diplomatic Information Architect', date: '2 days ago' }
      ]
  });

  // State for toggling between different views
  const [selectedOption, setSelectedOption] = useState('option2');

  return (
    <div className="min-h-screen bg-stone-50 font-['Reddit_Sans',system-ui,sans-serif]">
      {/* Header */}
      <div className="bg-slate-900 border-b-2 border-slate-900">
        <div className="max-w-7xl mx-auto px-8 py-8">
          <div className="flex items-start justify-between mb-6">
            <div>
              <h1 className="text-2xl font-bold text-white mb-2">Essay Ideas Hub</h1>
              <p className="text-sm text-stone-300">Discover compelling topics and develop unique stories for your college essays</p>
            </div>
            <button className="px-5 py-3 bg-gold-400 text-slate-900 border border-slate-900 rounded-lg font-bold text-sm hover:bg-gold-500 transition-all active:scale-95">
              <Lightbulb className="inline w-4 h-4 mr-2" />
              AI Essay Ideas
            </button>
          </div>

          {/* Journey Status Bar */}
          <div className="flex items-center gap-6 text-sm">
          <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-indigo-500"></div>
              <span className="text-stone-300">Free Writes: <span className="text-white font-medium">{userState.freeWritesCount}</span></span>
            </div>
            <div className="flex items-center gap-2">   
              <div className="w-2 h-2 rounded-full bg-gold-300"></div>
              <span className="text-stone-300">Ideas Saved: <span className="text-white font-medium">{userState.savedIdeasCount}</span></span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-teal-400"></div>
              <span className="text-stone-300">Essays Started: <span className="text-white font-medium">{userState.essaysStarted}/{userState.essaysTotal}</span></span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-coral-400"></div>
              <span className="text-stone-300">Essay Slots: <span className="text-white font-medium">{userState.essaySlotsStarted}/{userState.essaySlots}</span></span>
            </div>
            {userState.assessmentComplete && (
              <div className="flex items-center gap-2">
                <CheckCircle2 className="w-4 h-4 text-azure-500" />
                <span className="text-stone-100 font-medium">Assessment Complete</span>
              </div>
            )}
          </div>
        </div>
      </div>
            {/* Contextual Status Banner */}
            {userState.assessmentComplete && userState.hasPersonalizedTopics && (
        <div className="bg-azure-50 border-b-2 border-azure-600">
          <div className="max-w-7xl mx-auto px-8 py-4">
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-azure-600 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <Sparkles className="w-3.5 h-3.5 text-white" />
              </div>
              <div>
                <p className="text-sm font-medium text-slate-900">
                  You've completed your strategic assessment - <span className="font-bold">12 personalized topics</span> ready to explore
                </p>
                <p className="text-xs text-azure-800 mt-1">Your Strategic Assessment Topics are curated based on your unique experiences and responses</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Option Selector */}
      <div className="bg-stone-50 border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-8 py-6">
          <div className="max-w-3xl mx-auto">
            <div className="flex gap-2 border-2 border-slate-900 rounded-lg p-1 bg-white">
              <button
                onClick={() => setSelectedOption('option1')}
                className={`flex-1 px-4 py-2 rounded text-sm font-medium transition-all ${
                  selectedOption === 'option1'
                    ? 'bg-slate-900 text-white'
                    : 'text-slate-700 hover:bg-stone-50'
                }`}
              >
                Free Writing
              </button>
              <button
                onClick={() => setSelectedOption('option2')}
                className={`flex-1 px-4 py-2 rounded text-sm font-medium transition-all ${
                  selectedOption === 'option2'
                    ? 'bg-slate-900 text-white'
                    : 'text-slate-700 hover:bg-stone-50'
                }`}
              >
                Essay Ideation
              </button>
              <button
                onClick={() => setSelectedOption('option3')}
                className={`flex-1 px-4 py-2 rounded text-sm font-medium transition-all ${
                  selectedOption === 'option3'
                    ? 'bg-slate-900 text-white'
                    : 'text-slate-700 hover:bg-stone-50'
                }`}
              >
                Essay Workspace
              </button>
              <button
                onClick={() => setSelectedOption('option4')}
                className={`flex-1 px-4 py-2 rounded text-sm font-medium transition-all ${
                  selectedOption === 'option4'
                    ? 'bg-slate-900 text-white'
                    : 'text-slate-700 hover:bg-stone-50'
                }`}
              >
                College Essay Slots
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Content based on selected option */}
      {selectedOption === 'option1' && (
        <div className="max-w-7xl mx-auto px-8 py-12">
          <div className="text-center text-slate-600 text-lg">
            Free Writing Content Here
          </div>
        </div>
      )}

      {selectedOption === 'option2' && (
        <>


      {/* Module View */}
      <div className="max-w-7xl mx-auto px-8 py-12">
        <div className="flex flex-col lg:flex-row gap-8">
          
          {/* Sidebar: Recent Activity */}
          <aside className="lg:w-80 flex-shrink-0">
            <div className="bg-white border border-slate-300 rounded-xl overflow-hidden sticky top-8">
              <div className="px-6 py-4 bg-stone-50">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-teal-400"></div>
                  <h3 className="text-xs font-bold text-slate-900 uppercase tracking-wide">Recent Activity</h3>
                </div>
              </div>
              <div className="p-4">
                <div className="space-y-2">
                  {userState.recentActivity.map((item, idx) => (
                    <button key={idx} className="w-full text-left p-3 border border-slate-300 rounded-lg hover:border-slate-900 hover:shadow-sm transition-all group">
                      <div className="flex items-start gap-3">
                        <div className={`w-2 h-2 rounded-full mt-1.5 ${
                          item.type === 'freewrite' ? 'bg-magenta-500' :
                          item.type === 'draft' ? 'bg-azure-500' :
                          'bg-teal-500'
                        }`}></div>
                        <div className="flex-1 min-w-0">
                          <p className="text-sm font-medium text-slate-900 truncate">{item.title}</p>
                          <p className="text-xs text-stone-600">{item.date}</p>
                        </div>
                        <ChevronRight className="w-4 h-4 text-slate-400 group-hover:text-slate-900 transition-colors flex-shrink-0" />
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </aside>

          {/* Main Content */}
          <div className="flex-1 min-w-0">

        {/* Your Ideas Section */}
        <div className="mb-12">
          <div className="bg-slate-900 border border-slate-900 rounded-xl overflow-hidden">
            <div className="px-6 py-3 bg-slate-900 ">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-teal-400"></div>
                <h2 className="text-white font-bold text-sm uppercase tracking-wide">Your Ideas</h2>
              </div>
            </div>
            <div className="p-6 bg-white">
              <button className="w-full text-left p-8 bg-white border border-slate-900 rounded-xl hover:shadow-lg transition-all group border-l-4 border-l-teal-500">
                <div className="flex items-start justify-between">
                  <div className="flex items-start gap-5">
                    <div className="w-12 h-12 bg-teal-600 border border-slate-900 rounded-lg flex items-center justify-center flex-shrink-0 shadow-sm">
                      <Bookmark className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <div className="flex items-center gap-3 mb-2">
                        <h3 className="text-xl font-bold text-slate-900">My Saved Ideas</h3>
                        {userState.savedIdeasCount > 0 && (
                          <span className="px-2 py-1 bg-teal-100 text-teal-800 text-xs font-bold rounded border border-teal-300">
                            {userState.savedIdeasCount} saved
                          </span>
                        )}
                      </div>
                      <p className="text-sm text-slate-700 mb-3">View and develop all your saved essay topics from interviews and assessments</p>
                      <div className="flex items-center gap-2 text-xs text-stone-600">
                        <div className="w-2 h-2 rounded-full bg-teal-600"></div>
                        <span>Browse, search, and manage your essay ideas</span>
                      </div>
                    </div>
                  </div>
                  <ArrowRight className="w-6 h-6 text-slate-400 group-hover:text-slate-900 group-hover:translate-x-1 transition-all flex-shrink-0" />
                </div>
              </button>
            </div>
          </div>
        </div>

        {/* Discover Topics Section */}
        <div className="mb-12">
          <div className="bg-slate-900 border border-slate-900 rounded-xl overflow-hidden">
            <div className="px-6 py-3 bg-slate-900 ">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-coral-400"></div>
                <h2 className="text-white font-bold text-sm uppercase tracking-wide">Discover Topics</h2>
              </div>
            </div>
            <div className="p-6 bg-white">
              <div className="grid grid-cols-2 gap-6">
                
                {/* Strategic Assessment Topics */}
                <button className="text-left p-6 bg-white border border-l-2 rounded-xl hover:shadow-lg hover:border-azure-600 transition-all group relative border-l-4 border-l-azure-500">
                  {/* Recommended Badge */}
                  {userState.assessmentComplete && (
                    <div className="absolute -top-3 -right-3 px-3 py-1 bg-gold-400 border border-slate-900 rounded-lg shadow-lg">
                      <div className="flex items-center gap-1.5">
                        <Star className="w-3 h-3 text-slate-900 fill-slate-900" />
                        <span className="text-xs font-bold text-slate-900 uppercase tracking-wide">Start Here</span>
                      </div>
                    </div>
                  )}
                  
                  <div className="flex items-start gap-4 mb-4">
                    <div className="w-10 h-10 bg-azure-600 border border-slate-900 rounded-lg flex items-center justify-center flex-shrink-0 shadow-sm">
                      <Target className="w-5 h-5 text-white" />
                    </div>
                    <div className="flex items-center gap-2">
                      <span className="px-2 py-1 bg-azure-600 text-white text-xs font-bold rounded uppercase tracking-wide border border-azure-700">Personalized</span>
                      {userState.hasPersonalizedTopics && (
                        <span className="px-2 py-1 bg-azure-100 text-azure-800 text-xs font-bold rounded border border-azure-300">
                          12 topics
                        </span>
                      )}
                    </div>
                  </div>
                  <h3 className="text-base font-bold text-slate-900 mb-2">Strategic Assessment Topics</h3>
                  <p className="text-sm text-slate-700 mb-3">Essay topics based on your assessment responses - develop stories you already have</p>
                  <div className="flex items-center gap-2 text-xs text-stone-600">
                    <div className="w-2 h-2 rounded-full bg-azure-600"></div>
                    <span>AI-curated topics based on your profile</span>
                  </div>
                </button>

                {/* Untold Stories */}
                <button className="text-left p-6 bg-white border hover:border-coral-500 rounded-xl hover:shadow-lg transition-all group border-l-4 border-l-coral-400">
                  <div className="flex items-start gap-4 mb-4">
                    <div className="w-10 h-10 bg-coral-500 border border-slate-900 rounded-lg flex items-center justify-center flex-shrink-0 shadow-sm">
                      <Sparkles className="w-5 h-5 text-white" />
                    </div>
                    <ArrowRight className="w-4 h-4 text-coral-500 group-hover:translate-x-1 transition-transform mt-1" />
                  </div>
                  <h3 className="text-base font-bold text-slate-900 mb-2">Untold Stories</h3>
                  <p className="text-sm text-slate-700 mb-3">Narrative opportunities found in-between-the-lines of your analysis</p>
                  <div className="flex items-center gap-2 text-xs text-stone-600">
                    <div className="w-2 h-2 rounded-full bg-coral-500"></div>
                    <span>Explore values and experiences that defined you</span>
                  </div>
                </button>

              </div>
            </div>
          </div>
        </div>

        {/* Guided Discovery Section */}
        <div className="mb-12">
          <div className="bg-slate-900 border border-slate-900 rounded-xl overflow-hidden">
            <div className="px-6 py-3 bg-slate-900 ">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-indigo-400"></div>
                <h2 className="text-white font-bold text-sm uppercase tracking-wide">Guided Discovery</h2>
              </div>
            </div>
            <div className="p-6 bg-white">
              <div className="grid grid-cols-3 gap-6">
                
                {/* Moments That Matter */}
                <button className="text-left p-6 bg-white border hover:border-gold-500 rounded-xl hover:shadow-lg transition-all group border-l-4 border-l-gold-400">
                  <div className="flex items-start gap-4 mb-4">
                    <div className="w-10 h-10 bg-gold-500 border border-slate-900 rounded-lg flex items-center justify-center flex-shrink-0 shadow-sm">
                      <BookOpen className="w-5 h-5 text-slate-900" />
                    </div>
                    <span className="px-2 py-1 bg-gold-400 text-slate-900 text-xs font-bold rounded uppercase tracking-wide border border-gold-600">Think Back</span>
                  </div>
                  <h3 className="text-base font-bold text-slate-900 mb-2">Moments That Matter</h3>
                  <p className="text-sm text-slate-700 mb-3">Discover essay topics in the details you notice and moments you remember</p>
                  <div className="flex items-center gap-2 text-xs text-stone-600">
                    <div className="w-2 h-2 rounded-full bg-gold-500"></div>
                    <span>Fast idea generation for inspiration</span>
                  </div>
                </button>

                {/* Hidden Competencies */}
                <button className="text-left p-6 bg-white border hover:border-teal-600 rounded-xl hover:shadow-lg transition-all group border-l-4 border-l-teal-500">
                  <div className="flex items-start gap-4 mb-4">
                    <div className="w-10 h-10 bg-teal-600 border border-slate-900 rounded-lg flex items-center justify-center flex-shrink-0 shadow-sm">
                      <MessageCircle className="w-5 h-5 text-white" />
                    </div>
                    <span className="px-2 py-1 bg-teal-500 text-white text-xs font-bold rounded uppercase tracking-wide border border-teal-700">AI Interview</span>
                  </div>
                  <h3 className="text-base font-bold text-slate-900 mb-2">Hidden Competencies</h3>
                  <p className="text-sm text-slate-700 mb-3">AI-guided interview to uncover your unique strengths and unexpected stories</p>
                  <div className="flex items-center gap-2 text-xs text-stone-600">
                    <div className="w-2 h-2 rounded-full bg-teal-600"></div>
                    <span>Reveal your tactical approach</span>
                  </div>
                </button>

                {/* Character & Identity */}
                <button className="text-left p-6 bg-white border hover:border-indigo-500 rounded-xl hover:shadow-lg transition-all group border-l-4 border-l-indigo-400">
                  <div className="flex items-start gap-4 mb-4">
                    <div className="w-10 h-10 bg-indigo-500 border border-slate-900 rounded-lg flex items-center justify-center flex-shrink-0 shadow-sm">
                      <User className="w-5 h-5 text-white" />
                    </div>
                    <span className="px-2 py-1 bg-indigo-500 text-white text-xs font-bold rounded uppercase tracking-wide border border-indigo-700">Deep Dive</span>
                  </div>
                  <h3 className="text-base font-bold text-slate-900 mb-2">Character & Identity</h3>
                  <p className="text-sm text-slate-700 mb-3">Deep-dive interview exploring your values, experiences, and what makes you unique</p>
                  <div className="flex items-center gap-2 text-xs text-stone-600">
                    <div className="w-2 h-2 rounded-full bg-indigo-500"></div>
                    <span>Progressive prompts unlock</span>
                  </div>
                </button>

              </div>
            </div>
          </div>
        </div>

        {/* Quick Tools Section */}
        <div className="bg-white border border-slate-900 rounded-xl overflow-hidden">
          <div className="px-6 py-4 bg-white border-b-2 border-magenta-400">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-magenta-500"></div>
              <h2 className="text-slate-900 font-bold text-sm uppercase tracking-wide">Quick Tools</h2>
            </div>
          </div>
          <div className="p-6 bg-white">
            <div className="grid grid-cols-2 gap-6">
              
              {/* Quick Brainstorm */}
              <button className="text-left p-6 bg-white border border-slate-300 rounded-xl hover:border-slate-900 hover:shadow-md transition-all group border-l-4 border-l-magenta-500">
                <div className="flex items-start gap-4 mb-3">
                  <div className="w-8 h-8 bg-magenta-500 border border-slate-900 rounded-lg flex items-center justify-center flex-shrink-0 shadow-sm">
                    <Zap className="w-4 h-4 text-white" />
                  </div>
                  <div className="flex items-center gap-2">
                    <h3 className="font-bold text-slate-900 text-base">Quick Brainstorm</h3>
                    <Clock className="w-3.5 h-3.5 text-stone-500" />
                    <span className="text-xs text-stone-600">10 min</span>
                  </div>
                </div>
                <p className="text-sm text-slate-700 mb-3">10-minute rapid-fire session to generate essay angles you haven't considered</p>
                <div className="flex items-center gap-2 text-xs text-stone-600">
                  <div className="w-2 h-2 rounded-full bg-magenta-500"></div>
                  <span>Fast idea generation for immediate inspiration</span>
                </div>
              </button>

              {/* Essay Idea Generator */}
              <button className="text-left p-6 bg-white border border-slate-300 rounded-xl hover:border-slate-900 hover:shadow-md transition-all group border-l-4 border-l-azure-500">
                <div className="flex items-start gap-4 mb-3">
                  <div className="w-8 h-8 bg-azure-500 border border-slate-900 rounded-lg flex items-center justify-center flex-shrink-0 shadow-sm">
                    <Compass className="w-4 h-4 text-white" />
                  </div>
                  <h3 className="font-bold text-slate-900 text-base">Essay Idea Generator</h3>
                </div>
                <p className="text-sm text-slate-700 mb-3">Find essay topics through objects that matter to you</p>
                <div className="flex items-center gap-2 text-xs text-stone-600">
                  <div className="w-2 h-2 rounded-full bg-azure-500"></div>
                  <span>Progressive prompts unlock as you complete</span>
                </div>
              </button>

            </div>
          </div>
        </div>

          </div>
          {/* End Main Content */}

        </div>
        {/* End flex container */}
      </div>
      {/* End Module View */}
      </>
      )}

      {selectedOption === 'option3' && (
        <div className="max-w-7xl mx-auto px-8 py-12">
          <div className="text-center text-slate-600 text-lg">
            Essay Workspace Content Here
          </div>
        </div>
      )}

      {selectedOption === 'option4' && (
        <div className="max-w-7xl mx-auto px-8 py-12">
          <div className="text-center text-slate-600 text-lg">
            College Essay Slots Content Here
          </div>
        </div>
      )}

    </div>
  );
}